import { createContext, MutableRefObject } from 'react'
import { TemplateModel } from 'cakemail-ui-components-v2'
import { TSystemEmailsContainerContext } from './types'
import { ESystemEmailType } from '../../components/systemEmails/tableListing/types'


export const SystemEmailsContainerContext = createContext<TSystemEmailsContainerContext>({
    currentTab: { current: ESystemEmailType.accountConfirm }
})